import React from 'react';
import { PaginationWrapper } from '@jetshop/ui/Pagination/Pagination';
import { Pagination as UIPagination } from '@jetshop/ui/Pagination';
import { css } from 'linaria';

export function Pagination(props) {
  return (
    <PaginationWrapper>
      <UIPagination {...props} className={paginationStyles} />
    </PaginationWrapper>
  );
}

const paginationStyles = css`
  a {
    padding: 5px 15px;
    color: black;
    border: 1px solid black;
    text-decoration: none;
    transition: all, 0.2s ease;
    &:hover {
      background: black;
      color: white;
    }
  }
  a[data-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
    color: #777;
  }
`;
